module.exports = __webpack_public_path__ + "img/default1.49d9d341.svg";